import { render, staticRenderFns } from "./CharButton.vue?vue&type=template&id=3b88d4c2&"
import script from "./CharButton.vue?vue&type=script&lang=js&"
export * from "./CharButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports